import React from "react";

const CorporateCarRental = () => {
  return (
    <>
      {/* ===== BREADCRUMB / BANNER ===== */}
      <section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Corporate Car Rental Services</h1>
          </div>
        </div>
      </section>

      {/* ===== MAIN CONTENT ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-md-6 mb-4">
              <img
                src="/images/gallery/10.jpeg"
                alt="Corporate Car Rental Pune"
                className="img-fluid rounded shadow"
              />
            </div>

            {/* CONTENT */}
            <div className="col-md-6">
              <h2 className="mb-3">
                <span className="text-danger">Corporate</span> Car Rental in Pune
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. offers reliable, professional,
                and premium corporate car rental services tailored to meet the
                transportation needs of businesses, multinational companies,
                IT firms, manufacturing units, and corporate executives.
              </p>

              <p>
                With years of experience in corporate mobility management,
                we understand the importance of punctuality, safety, comfort,
                and service consistency. Our chauffeur-driven cars ensure that
                your executives and guests travel seamlessly across Pune and
                other major cities in India.
              </p>

              <p>
                Whether it is daily office travel, airport transfers, client
                meetings, conferences, or long-term corporate contracts, our
                fleet and service team are structured to deliver unmatched
                reliability and professionalism.
              </p>

              <h5 className="mt-4 mb-2">Why Choose Pune Corporate Cars?</h5>

              <ul className="list-unstyled">
                <li>✔ Well-maintained premium corporate fleet</li>
                <li>✔ Uniformed, trained & background-verified chauffeurs</li>
                <li>✔ Flexible monthly & long-term corporate contracts</li>
                <li>✔ Transparent billing with MIS & reporting</li>
                <li>✔ 24×7 customer support & operations team</li>
                <li>✔ Strong focus on safety, hygiene & compliance</li>
              </ul>

              <p className="mt-3">
                Our corporate car rental solutions are designed to reduce
                operational stress for your organization while ensuring a
                smooth and professional travel experience for your employees
                and business partners.
              </p>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default CorporateCarRental;
